import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main" }

import PogoList from '@/components/PogoList.vue'
import { useStore } from '@/store'
import { typeColors, types } from '@/types/type'
import PogoFilter from '@/components/PogoFilter.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore()

store.dispatch('getPokemonList')

const root = document.querySelector(':root') as HTMLElement
types.forEach(type => {
  root.style.setProperty(`--${type}`, typeColors[type])
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createVNode(PogoList)
    ]),
    _createVNode(PogoFilter)
  ], 64))
}
}

})